// Pure helper shared by the import dialog (and its tests): pairs the files an
// admin drops in with the export's audio manifest.

import type { ExportAudioFile } from '../../api/client';

/** Match dropped files to the export's audio manifest: by `<id>.wav` (what the
 *  script writes) or by the original Teams file name. */
export function matchAudioFiles(files: File[], manifest: ExportAudioFile[]): Array<{ file: File; entry: ExportAudioFile | null }> {
  const byId = new Map(manifest.map(m => [m.id.toLowerCase(), m]));
  const byName = new Map(manifest.filter(m => m.fileName).map(m => [m.fileName!.toLowerCase(), m]));
  return files.map(file => {
    const base = file.name.replace(/\.[a-z0-9]+$/i, '').toLowerCase();
    const entry = byId.get(base) || byName.get(file.name.toLowerCase()) || null;
    return { file, entry };
  });
}
